import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge configured for our design-system scales so that className
 * overrides dedupe correctly. Without this, `cn("rounded-card", "rounded-xl")`
 * would keep BOTH classes (tailwind-merge wouldn't know they conflict) and the
 * result would depend on stylesheet order. Registering the custom values makes
 * the *last* class win, which is what callers expect.
 *
 * Keep these lists in sync with the tokens in tailwind.config.js theme.extend.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      rounded: [{ rounded: ["control", "card", "modal", "pill"] }],
      shadow: [{ shadow: ["e0", "e1", "e2", "e3", "e4"] }],
      h: [{ h: ["control-sm", "control", "control-lg"] }],
      w: [{ w: ["control-sm", "control", "control-lg"] }],
      "min-h": [{ "min-h": ["control-sm", "control", "control-lg"] }],
    },
  },
});

/** Merge conditional class names, resolving Tailwind conflicts (last wins). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
